// extracted by mini-css-extract-plugin
export default {"root":"SuggestedQuestionsSubForm_root__URPrE","body":"SuggestedQuestionsSubForm_body__0JERu"};